var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkWellbankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    id: "clip0_28_14686",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: "none",
    strokeLinecap: "none",
    strokeLinejoin: "none",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3377,1.41432c-3.66296,1.48208 -7.26664,3.54242 -9.82779,6.18096c-0.50396,0.5192 -0.09883,1.31955 0.63918,1.31955h19.70261c0.738,0 1.1431,-0.80035 0.6393,-1.31955c-2.5612,-2.63854 -6.1649,-4.69888 -9.8279,-6.18096c-0.424,-0.17157 -0.9014,-0.17157 -1.3254,0z",
    stroke: "#e5eaf9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83561,17.5391c-2.08214,0 -3.08855,1.554 -3.43606,3.4575c-0.17127,0.9384 0.65567,1.7174 1.6449,1.7174h17.91145c0.9894,0 1.8163,-0.779 1.6449,-1.7174c-0.3475,-1.9035 -1.3538,-3.4575 -3.4359,-3.4575z",
    stroke: "#e5eaf9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83496,17.5393v-8.62475",
    stroke: "#e5eaf9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.001,17.5393v-8.62475",
    stroke: "#e5eaf9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.166,17.5393v-8.62475",
    stroke: "#e5eaf9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkWellbankIcon);
export default __webpack_public_path__ + "static/media/dark-wellbank-icon.b4008586cf7b537fbc9edbd7a229a63b.svg";
export { ForwardRef as ReactComponent };